import _filter from 'lodash/filter'
import _first from 'lodash/first'
import _orderBy from 'lodash/orderBy'

import {
    PRODUCT_TYPE_SELF_ASSESSMENT,
    PRODUCT_TYPE_TAX_CONSULTATION,
    SELF_ASSESSMENT_STATUS_CANCELLED,
    SELF_ASSESSMENT_STATUS_COMPLETED_NOT_FILED,
    SELF_ASSESSMENT_STATUS_FILED,
    SELF_ASSESSMENT_STATUS_FILED_AWAITING_REFUND,
    TAX_CONSULTATION_STATUS_CANCELLED,
    TAX_CONSULTATION_STATUS_COMPLETED,
} from '@/constants'
import { getProfile } from '@/store/profile'

const getProductBundleItems = (state) => state.productBundles.items

export const getLatestProductBundle = (state) => {
    const items = getProductBundleItems(state)
    const orderedItems = _orderBy(items, 'id', 'desc')
    return _first(orderedItems)
}

export const getProductBundleForUpsell = (state, { baseProductType, baseProductId }) => {
    const items = getProductBundleItems(state)

    const filteredItems = _filter(items, (productBundle) => {
        if (baseProductType === PRODUCT_TYPE_SELF_ASSESSMENT) {
            return !productBundle.selfAssessmentId || productBundle.selfAssessmentId === baseProductId
        }

        if (baseProductType === PRODUCT_TYPE_TAX_CONSULTATION) {
            return !productBundle.taxConsultationId || productBundle.taxConsultationId === baseProductId
        }

        return true
    })

    const orderedItems = _orderBy(filteredItems, 'id', 'desc')

    return _first(orderedItems)
}

export const getHasPaidLatestProductBundle = (state) => !!getLatestProductBundle(state)?.hasPaid

export const getHasPaidProductBundles = (state) => !!getProductBundleItems(state).find(({ hasPaid }) => hasPaid)

export const getHasStartedLatestProductBundleTaxConsultation = (state) =>
    !!getLatestProductBundle(state)?.taxConsultationId

export const getHasStartedLatestProductBundleSelfAssessment = (state) =>
    !!getLatestProductBundle(state)?.selfAssessmentId

export const getHasStartedUsingLatestProductBundle = (state) =>
    getHasStartedLatestProductBundleSelfAssessment(state) || getHasStartedLatestProductBundleTaxConsultation(state)

const getHasActiveSelfAssessmentsInProductBundles = (state) => {
    const { selfAssessments } = getProfile(state)
    const items = getProductBundleItems(state)

    return !!items.find((item) =>
        selfAssessments.find(
            ({ id, status }) =>
                id === item.selfAssessmentId &&
                status !== SELF_ASSESSMENT_STATUS_CANCELLED &&
                status !== SELF_ASSESSMENT_STATUS_COMPLETED_NOT_FILED &&
                status !== SELF_ASSESSMENT_STATUS_FILED &&
                status !== SELF_ASSESSMENT_STATUS_FILED_AWAITING_REFUND
        )
    )
}

const getHasActiveTaxConsultationsInProductBundles = (state) => {
    const { taxConsultations } = getProfile(state)
    const items = getProductBundleItems(state)

    return !!items.find((item) =>
        taxConsultations.find(
            ({ id, status }) =>
                id === item.taxConsultationId &&
                status !== TAX_CONSULTATION_STATUS_COMPLETED &&
                status !== TAX_CONSULTATION_STATUS_CANCELLED
        )
    )
}

const getHasPaidNotStartedProductBundles = (state) => {
    const items = getProductBundleItems(state)

    return !!items.find((item) => item.hasPaid && (item.selfAssessmentId === null || item.taxConsultationId === null))
}

const getHasUnfinishedProductBundles = (state) => {
    const items = getProductBundleItems(state)

    return !!items.find((item) => item.selfAssessmentId === null || item.taxConsultationId === null)
}

export const getHasActiveProductBundle = (state) =>
    getHasPaidNotStartedProductBundles(state) ||
    getHasActiveSelfAssessmentsInProductBundles(state) ||
    getHasActiveTaxConsultationsInProductBundles(state)

export const getShouldCreateProductBundle = (state) => !getHasUnfinishedProductBundles(state)
